import 'normalize.css';
import 'u9-internal-components/src/styles/_index.scss';
import 'u9-internal-components/src/styles/global/_index.scss';
import 'u9-internal-components/src/components/componentStyles';
import './index.scss';

import '!file-loader?name=static/media/[name].[ext]!./assets/images/unsupported_logo.png';
import isSupported, { isDesktop } from './utils/isSupported';

const loadApp = () => {
  const preloader = document.querySelector('.App-preloader');
  preloader.style.display = 'block';
  import('./app');
};

const showUnsupported = () => {
  const platformClass = isDesktop() ? 'desktop' : 'mobile';
  document.body.className += ` unsupported ${platformClass}`;
};

if (isSupported()) {
  loadApp();
} else {
  showUnsupported();
}



// WEBPACK FOOTER //
// ./src/index.js